export default "__VITE_ASSET__b0dcc705__"